import type { PatientStrings } from '../index';

export const gu: PatientStrings = {
  titleOne: 'તમારો નવો ક્રાઉન',
  titleMany: 'તમારા નવા ક્રાઉન',
  tooth: 'દાંત',
  teeth: 'દાંત',
  both: 'બંને',
  overview: 'આખું દૃશ્ય',
  front: 'સામેથી',
  leftSide: 'ડાબી બાજુ',
  rightSide: 'જમણી બાજુ',
  bitingSurface: 'ચાવવાની સપાટી',
  show: 'બતાવો',
  newCrown: 'નવો ક્રાઉન',
  newCrowns: 'નવા ક્રાઉન',
  yourTeeth: 'તમારા દાંત અને પેઢાં',
  upperTeeth: 'ઉપરના દાંત',
  lowerTeeth: 'નીચેના દાંત',
  hint: 'ફેરવવા માટે ખેંચો · ઝૂમ માટે પિંચ કે સ્ક્રોલ કરો',
  zoomIn: 'નજીક',
  zoomOut: 'દૂર',
  turnSlowly: 'ધીમે ફેરવો',
  stopTurning: 'ફેરવવાનું બંધ કરો',
  backToStart: 'શરૂઆત પર પાછા',
  fullScreen: 'પૂર્ણ સ્ક્રીન',
  exitFullScreen: 'પૂર્ણ સ્ક્રીનમાંથી બહાર',
  fromDentist: 'તમારા ડેન્ટિસ્ટ તરફથી',
  shadeNote: (shade) =>
    `રંગ લગભગ શેડ ${shade} જેવો બતાવ્યો છે. અસલી ક્રાઉનનો રંગ લેબમાં મેળવવામાં આવે છે.`,
  before: 'પહેલાં',
  after: 'પછી',
  seeInRoom: 'તમારા રૂમમાં જુઓ',
  arNotSupported: 'ક્રાઉનને તમારા રૂમમાં જોવા માટે આ પેજ તમારા ફોન પર ખોલો.',
  appointmentTitle: 'ક્રાઉન લગાવવાની તમારી એપોઇન્ટમેન્ટ',
  confirm: 'પુષ્ટિ કરો',
  confirmed: 'પુષ્ટિ થઈ — ત્યારે મળીએ',
  anotherTime: 'બીજો સમય માગો',
  anotherTimeSent: 'તમને બીજો સમય જોઈએ છે તે અમે તમારા ડેન્ટિસ્ટને જણાવ્યું છે.',
  language: 'ભાષા',
  largerText: 'મોટા અક્ષર',
};
